import Link from 'next/link'
import { LazyImage } from '@components/common/image'
import useSegment, { SegmentEventEnum } from '@hooks/useSegment'

type Props = {
  isLoggedIn: boolean
  competitionSlug: string
  handleReferralRegister: (slug: string) => void
}

const ReferralBanner = ({
  isLoggedIn,
  competitionSlug,
  handleReferralRegister,
}: Props) => {
  const track = useSegment()

  return (
    <div
      onClick={() =>
        track(SegmentEventEnum.COMPETITION_PAGE_REFERRAL_BANNER_CLICK)
      }
    >
      {isLoggedIn && (
        <Link href={`/competitions/${competitionSlug}/invite`}>
          <a>
            <LazyImage
              path="/images/competitions/"
              name="referral-program"
              alt="Codingal competition referral program"
            />
          </a>
        </Link>
      )}

      {!isLoggedIn && (
        <button onClick={() => handleReferralRegister(competitionSlug)}>
          <LazyImage
            path="/images/competitions/"
            name="referral-program"
            alt="Codingal competition referral program"
          />
        </button>
      )}
    </div>
  )
}

export default ReferralBanner
